import React, { Component, Fragment } from 'react'

import { connect } from 'react-redux'

import { fetchHomeInfo } from 'actions/cms/homeInfo'
import Button from 'components/button'
import RichText from 'components/rich-text'
import e2eClasses from 'helpers/automation'
import { isMobileOrTablet } from 'helpers/utils'
import { getHomeInfo } from 'selectors/cms/homeInfo'
import { mapMediaType } from 'selectors/mediaType'

import {
  Section,
  Img,
  Items,
  Title,
  ButtonContainer,
  Row,
  Column,
  Icon,
  IconContainer,
  TitleBlue
} from './styled'

const ButtonHomeInfo = ({ url, text, handleClick, paddingTop }) => (
  <ButtonContainer paddingTop={paddingTop}>
    <Button
      onClick={() => handleClick(url)}
      e2eClass={e2eClasses('home.information.button')}
      padding={'11px 0'}
    >
      {text}
    </Button>
  </ButtonContainer>
)

class HomeInfo extends Component {
  componentDidMount = () => !this.props.sections && this.props.fetchHomeInfo()

  handleClick = path => (window.location = path)

  render = () => {
    const sections = this.props.sections || this.props.info
    const { reference, withIcons, isMobile } = this.props

    if (!sections) {
      return null
    }
    return (
      <Fragment>
        {(sections || []).map((section, index) => (
          <Section
            ref={
              reference &&
              (elem => {
                reference[section.menuId] = elem
              })
            }
            centered={withIcons || isMobile}
            key={index}
          >
            <Img src={section.image} alt={section.alternText || ''} />
            {withIcons ? (
              <Items withIcons>
                <Title>{section.title}</Title>
                <Row repeat={section.items.length}>
                  {(section.items || []).map((item, index) => (
                    <Column key={index}>
                      <IconContainer href={item.iconUrl} title={`${item.iconName} link`}>
                        <Icon src={item.icon} alt="" />
                      </IconContainer>
                      {item.iconName}
                    </Column>
                  ))}
                </Row>
                {section.buttonText && (
                  <ButtonHomeInfo
                    url={section.url}
                    text={section.buttonText}
                    handleClick={this.handleClick}
                  />
                )}
              </Items>
            ) : (
              <Items>
                {section.showTitle && <TitleBlue>{section.title}</TitleBlue>}
                <RichText maxWidth="450px" text={section.description} />
                {section.buttonText && (
                  <ButtonHomeInfo
                    url={section.url}
                    text={section.buttonText}
                    handleClick={this.handleClick}
                    paddingTop
                  />
                )}
              </Items>
            )}
          </Section>
        ))}
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  info: getHomeInfo(state),
  isMobile: isMobileOrTablet(mapMediaType(state))
})

const mapDispatchToProps = {
  fetchHomeInfo
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeInfo)
